const selectiveCoursePlay = {
  path: 'selectiveCoursePlay',
  component: resolve => require(['../../../../pages/user/videoplay/selectivecourseplay'], resolve)
}

export default selectiveCoursePlay



// WEBPACK FOOTER //
// ./src/router/user/videoplay/selectivecourseplay/index.js